import React from 'react';
import { TaskyDialog, TaskyButton } from '../tasky';
import { useMetaLang, SB_STRINGS } from '../../i18n/metaReviewLang';

export interface CardLockDialogProps {
  open: boolean;
  featureName: string;
  onClose: () => void;
  onRegister: () => void;
}

/**
 * カード未登録の組織がロック中の機能（動画広告・漫画広告）をクリックしたときに出す誘導ダイアログ。
 * presentational: Router / Redux には依存せず、遷移は onRegister で呼び出し側に委ねる。
 */
const CardLockDialog: React.FC<CardLockDialogProps> = ({
  open,
  featureName,
  onClose,
  onRegister,
}) => {
  const [metaLang] = useMetaLang();
  const sb = SB_STRINGS[metaLang];

  return (
    <TaskyDialog
      open={open}
      onClose={onClose}
      title={sb.cardLockTitle.replace('{name}', featureName)}
      size="sm"
      footer={
        <>
          <TaskyButton variant="outline" onClick={onClose}>
            {sb.cardLockLater}
          </TaskyButton>
          <TaskyButton variant="default" onClick={onRegister}>
            {sb.cardLockCta}
          </TaskyButton>
        </>
      }
    >
      <p className="text-sm text-gray-600 leading-relaxed">{sb.cardLockDesc}</p>
    </TaskyDialog>
  );
};

export default CardLockDialog;
